/**
 * Error hierarchy used throughout Pulse Protocol. All errors extend the base
 * `PulseError` class so consumers can catch everything with one instanceof.
 */

export class PulseError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "PulseError";
    Object.setPrototypeOf(this, PulseError.prototype);
  }
}

/** A scan failed entirely (one or more detectors could not run). */
export class ScanError extends PulseError {
  readonly detector?: string;
  constructor(message: string, detector?: string) {
    super(message);
    this.name = "ScanError";
    this.detector = detector;
    Object.setPrototypeOf(this, ScanError.prototype);
  }
}

/** A data source (Helius, X, DexScreener) returned an error or timed out. */
export class SourceError extends PulseError {
  readonly source: string;
  readonly status?: number;
  constructor(source: string, message: string, status?: number) {
    super(`${source}: ${message}`);
    this.name = "SourceError";
    this.source = source;
    this.status = status;
    Object.setPrototypeOf(this, SourceError.prototype);
  }
}

/** A published verdict failed signature verification. */
export class SignatureError extends PulseError {
  constructor(message: string) {
    super(message);
    this.name = "SignatureError";
    Object.setPrototypeOf(this, SignatureError.prototype);
  }
}
